import React from 'react';
import SpeechBubble from '../../../icons/SpeechBubble';

const Prompt = ({ show, promptState }) => {
  return (
    <span className={`prompt ${ promptState }`} data-active={ show }>

      { promptState === 'bot' && <SpeechBubble /> }

    </span>
  )
}

export default Prompt